<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'orders'">
  <div class="card" style="min-height:200px">
    <div class="header-card">
      <div class="container-title">
        <h2 class="title-main">{{'UserPages.UserPurchaseOrders.PageTitle' | translate}}</h2>
      </div>
    </div>
    <div class="body-card pt-small">
      <div class="flex justify-content-between">
        <p-tabMenu [model]="tabMenuItems" [scrollable]="true" [activeItem]="activeItem" [style]="{padding: '15px', 'margin-top':'0'}"></p-tabMenu>

        <div class="flex justify-content-start align-items-center">
          <p-tag [style]="{'background-color': '#f4f4f4','color':'#000', 'font-weight':'500','font-style':'italic','padding':'.5em 1em'}" >{{'UserPages.UserPurchaseOrders.MessageTotalText' | translate}}</p-tag>
        </div>
      </div>
      <div class="custom-header-table">
        <p-table [value]="orders"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [loading]="loading"
          responsiveLayout="stack"
          [breakpoint]="'600px'"
          [globalFilterFields]="['status']">
          <ng-template pTemplate="header">
            <tr>
              <th rowspan="2">
                <div class="flex justify-content-left align-items-center cell-header-text">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.Specie/VarietyHeader' | translate}}
                </div>
              </th>
              <th rowspan="2">
                <div class="flex justify-content-center align-items-center cell-header-text">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.TotalHeader' | translate}}
                </div>
              </th>
              <th rowspan="2">
                <div class="flex justify-content-center align-items-center cell-header-text">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.CodeHeader' | translate}}
                </div>
              </th>

              <th colspan="2" style="border: none;">
                <div class="flex justify-content-center align-items-center category-top">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.VerificationHeader' | translate}}
                </div>
              </th>
              <th colspan="2" style="border: none;">
                <div class="flex justify-content-center align-items-center category-top">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.ConfirmationHeader' | translate}}
                </div>
              </th>

              <th rowspan="2">
                <div class="flex justify-content-center align-items-center cell-header-text">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.ActionsHeader' | translate}}
                  <p-columnFilter field="status" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false" [matchMode]="'equals'" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)">
                            <ng-template let-option pTemplate="item">
                                <span>{{ option.label }}</span>
                            </ng-template>
                        </p-dropdown>
                    </ng-template>
                </p-columnFilter>
                </div>
              </th>
              <th rowspan="2">
                <div class="flex justify-content-center align-items-center cell-header-text">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.InfoHeader' | translate}}
                </div>
              </th>
            </tr>

            <tr>
              <th>
                <div class="flex justify-content-center align-items-center category-bottom">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.ExporterHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center category-bottom">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.QualityHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center category-bottom">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.ImporterHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center category-bottom">
                  {{'UserPages.UserPurchaseOrders.CurrentTable.PaymentHeader' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-order>
            <tr>
              <td class="flex">
                <!--
                <figure style="border-radius: 7px; width: 120px; height: 100px; display: flex; justify-content: center; align-items: center; margin:0; overflow:hidden" >
                  <img [src]="getPictureUrl(order.pictureUrl)" style="width: 100%; height: 100%, object-fit: cover;" alt="Product picture"/>
                </figure>
              -->

                <div class="container-img">
                  <img  loading="lazy" [src]="getIconUrl(order.details[0].varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; height: auto;" alt="" *ngIf="order.details[0].varietyUrlIcon"/>
                  <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!order.details[0].varietyUrlIcon">
                    no_photography
                  </span>
                </div>

                <div class="flex justify-content-start align-items-center">
                  <div style="text-align:left;padding-left:.5em">
                    <ng-container *ngFor="let detail of order.details">
                      <strong>{{ getSpeciesName(detail) }}</strong>
                      <br *ngIf="getSpeciesName(detail) !== ''">
                      {{detail.varietyName}}
                      <br *ngIf="getSpeciesName(detail) !== ''">
                    </ng-container>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <span style="font-weight: bold; color:#8C2B87">{{ order.totalPrice | currency: 'USD':'US$'}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  {{ getOrderTitle(order) }}
                  <br *ngIf="getOrderTitle(order) !== ''">
                  {{ order.created | date: 'dd-MM-yyyy'}}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <div class="flex justify-content-center align-items-center circle-pending" *ngIf="order.status < 1">
                    <i class="pi pi-ellipsis-h" style="color: #8f8f8f" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ExporterPendingTooltip' | translate}}"></i>
                  </div>
                  <div class="flex justify-content-center align-items-center circle-check" *ngIf="order.status >= 1">
                    <i class="pi pi-check-circle" style="color: #689F38" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ApprovedTooltip' | translate}}"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <div class="flex justify-content-center align-items-center circle-pending" *ngIf="order.status < 2">
                    <i class="pi pi-ellipsis-h" style="color: #8f8f8f" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.QcPendingTooltip' | translate}}"></i>
                  </div>
                  <div class="flex justify-content-center align-items-center circle-check" *ngIf="order.status >= 2">
                    <i class="pi pi-check-circle" style="color: #689F38" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ApprovedTooltip' | translate}}"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <div class="flex justify-content-center align-items-center circle-pending" *ngIf="order.status < 3">
                    <i class="pi pi-ellipsis-h" style="color: #8f8f8f" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ImporterConfirmationTooltip' | translate}}"></i>
                  </div>
                  <div class="flex justify-content-center align-items-center circle-check" *ngIf="order.status >= 3">
                    <i class="pi pi-check-circle" style="color: #689F38" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ApprovedTooltip' | translate}}"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <div class="flex justify-content-center align-items-center circle-pending" *ngIf="order.status < 4">
                    <i class="pi pi-ellipsis-h" style="color: #8f8f8f" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.QcConfirmationTooltip' | translate}}"></i>
                  </div>
                  <div class="flex justify-content-center align-items-center circle-check" *ngIf="order.status >= 4">
                    <i class="pi pi-check-circle" style="color: #689F38" pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ApprovedTooltip' | translate}}"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center icon-status" *ngIf="order.status==4">
                  <p-tag
                    *ngIf="order.status != null && statuses[order.status]"
                    [value]="statuses[order.status].label"
                    [severity]="getStatusSeverity(order.status)"
                    [icon]="getStatusIcon(order.status)"
                    [style]="{'background-color': '#F1F9EA','color':'#6DA043','font-weight':'600','padding':'.5em 1em','font-size':'.9em'}"
                    pTooltip="{{'UserPages.UserPurchaseOrders.CurrentTable.TooltipsBody.ConfirmedPaymentTooltip' | translate}}"
                  >
                  </p-tag>
                </div>
                <div class="flex justify-content-center align-items-center icon-status" *ngIf="order.status!==4">
                  <p-tag
                    *ngIf="order.status != null && statuses[order.status]"
                    [value]="statuses[order.status].label | translate"
                    [severity]="getStatusSeverity(order.status)"
                    [icon]="getStatusIcon(order.status)"
                    [style]="{'background-color': '#FFF4E0','color':'#F89F24','font-weight':'600','padding':'.5em 1em','font-size':'.9em'}"
                  >
                  </p-tag>
                </div>
              </td>
              <td>
                <div class="flex justify-content-end align-items-center gap-4">
                  <p-button
                    styleClass="p-button-sm"
                    pTooltip="Ver orden"
                    [style]="{'line-height':'1.1em','padding':'.5em .7em','font-size':'.9em'}"
                    (onClick)="goToOrderDetailPage(order.id)"
                    label="{{'UserPages.UserPurchaseOrders.CurrentTable.ViewOrderBtn' | translate}}"
                  ></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</app-user-dashboard>
